import { render, staticRenderFns } from "@/modules/Contact/templates/contact-detail.html?vue&type=template&id=7e37fc25&scoped=true&"
import script from "@/modules/Contact/scripts/contact-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/Contact/scripts/contact-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Contact/styles/contact-detail.scss?vue&type=style&index=0&id=7e37fc25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e37fc25",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
